import { render } from "./CustomWebMobileUxUiDesign.vue?vue&type=template&id=cb57db38&scoped=true"
import script from "./CustomWebMobileUxUiDesign.vue?vue&type=script&lang=js"
export * from "./CustomWebMobileUxUiDesign.vue?vue&type=script&lang=js"

import "./CustomWebMobileUxUiDesign.vue?vue&type=style&index=0&id=cb57db38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb57db38"]])

export default __exports__